var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal__comments" },
    [
      _vm._l(_vm.comments, function(comment, index) {
        return _c("Comment", {
          key: "comment-" + index,
          attrs: { comment: comment }
        })
      }),
      _vm._v(" "),
      _vm._l(_vm.blankComments, function(comment, index) {
        return _c("CommentSkeleton", { key: "blank-" + index })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }